import React from 'react';
import '../../App.css';
import GalleryTest from '../GalleryTest';
import './Services.css'

export default function Services() {
  return (
        <GalleryTest />
  );
}